import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center m-2" }
const _hoisted_2 = { class: "flex mb-5" }
const _hoisted_3 = { class: "w-full text-left mx-8" }
const _hoisted_4 = { class: "font-bold text-sm text-primary-main" }
const _hoisted_5 = { class: "font-bold text-sm" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "flex justify-center items-center mb-5" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardWithTitle = _resolveComponent("CardWithTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CardWithTitle, {
      title: _ctx.title,
      class: "sm:w-6/12 flex flex-col items-center"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entrySteps, (step, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "sm:w-5/12 md:w-8/12",
            key: step.title
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, " STEP " + _toDisplayString(index + 1), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(step.title), 1),
                _createElementVNode("p", {
                  class: "w-full text-xs text-left text-gray-500 break-all",
                  innerHTML: step.description
                }, null, 8, _hoisted_6)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: step.image_path
              }, null, 8, _hoisted_8)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}